import React, { HTMLAttributes, ReactNode } from 'react';
import '../../tailwind.css';

interface TailwindScopeProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  className?: string;
}

const TailwindScope = ({ children = null, className = '', ...props }: TailwindScopeProps) => {
  const scopeClassName = ['tw-enabled', 'font-sans', className].filter(Boolean).join(' ');

  return (
    <div className={scopeClassName} {...props}>
      {children}
    </div>
  );
};

export default TailwindScope;
